export const DISPLAY_CHECKOUT = 'DISPLAY_CHECKOUT'
export const HIDE_CHECKOUT = 'HIDE_CHECKOUT'
export const TOGGLE_VISIBILITY_CHECKOUT = 'TOGGLE_VISIBILITY_CHECKOUT'
